import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import BgParallax from "../components/parts/BgParallax"
import { ListGroup } from "react-bootstrap"
import Fade from "react-reveal/Fade"

import BgImg from "../images/entreprises.jpg"
import { RiArrowRightSLine } from "react-icons/ri"

const entreprises = () => {
  return (
    <Layout>
      <SEO title="Entreprises" />
      <div className="container pt-5">
        <div className="row">
          <div className="col-md-12 mb-5">
            <h2>Entreprises</h2>
          </div>
        </div>
      </div>
      <BgParallax
        gradient="linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.9)) 0% 0%"
        image={`url(${BgImg})`}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="text-center font-weight-bold mb-0">
                Dans le cadre de la prévention des risques psycho-sociaux et
                pour soutenir tous les projets de l’entreprise, la sophrologie
                propose une démarche pédagogique accessible et efficace à tous
                les niveaux de l’entreprise, en accompagnement individuel ou
                collectif.
              </p>
            </div>
          </div>
        </div>
      </BgParallax>

      <div className="container py-5">
        <div className="row">
          <Fade bottom cascade>
            <div className="col-md-12">
              <p>
                Je me déplace au sein de votre structure afin de réaliser des
                séances collectives pour initier vos collaborateurs à la
                sophrologie en fonction des objectifs souhaités, par exemple :
              </p>
              <ListGroup variant="flush">
                {[
                  "Développer ses capacités d’adaptation pour réduire les effets nocifs du stress",
                  "Améliorer la qualité de son sommeil et ses capacités de vigilance",
                  "Améliorer sa concentration, gagner en efficacité personnelle",
                  "Mieux gérer son énergie",
                  "Cohésion d’équipe, amélioration des relations interpersonnelles (faciliter le travail en équipe)",
                  "Développement des qualités relationnelles (écoute, bienveillance, non jugement, respect,…)",
                  "Accompagnement de la mobilité interne (ex : prise de poste, accès à de nouvelles responsabilités)",
                  "Accompagnement du changement (développer un regard plus positif sur le changement, percevoir de nouvelles opportunités)",
                  "Développer sa confiance en soi",
                  "Prise de parole en public",
                  "Mieux appréhender les situations à forts enjeux (négociations importantes)",
                  "Faire face à l’agressivité d’un public, de la clientèle",
                  "Prévention des T.M.S., des douleurs",
                  "Développement de la créativité",
                ].map((item, i) => {
                  return (
                    <ListGroup.Item key={i}>
                      <RiArrowRightSLine className="color-primary  mr-1" />
                      {item}
                    </ListGroup.Item>
                  )
                })}
              </ListGroup>
              <br />
              <p>
                Merci de <Link to="/contact">me consulter</Link> pour définir un
                programme sur mesure et obtenir un devis.
              </p>
            </div>
          </Fade>
        </div>
      </div>
    </Layout>
  )
}

export default entreprises
